export default __webpack_public_path__ + "static/media/previous.d357e8f5.svg";